<template>
  <div class="container">
    <div class="containerER">
      <div class="nav-tab">
        <div style="display: flex">
          <img src="../../assets/images/arrow.png" class="ims" alt="" />
          <div>您的当前位置是：首页-文章详情</div>
        </div>
        <!-- <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div> -->
      </div>
      <div class="content">
        <div :class="[textobj.isSpecial == 0 ? 'red' : 'title']" style="margin: 0 40px 16px 40px">
          {{ textobj.messageName }}
        </div>
        <div class="line"></div>
        <div class="info">
          <span>作者：{{ textobj.author }}</span>
          <span style="margin: 0 7px">出处：{{ textobj.source }}</span>
          <span>时间：{{ textobj.releaseTime }}</span>
        </div>
        <div style="text-align: right;padding-right: 50px;">
          <div>
            <span style="font-size: 14px;">浏览次数：</span>
            <span style="font-size: 20px;color: #2E5BB6;">{{ textobj.viewTimes }}</span>
          </div>
        </div>
        <el-image-viewer v-if="isShowPics" :on-close="closeViewer" :url-list="[imgPreview.img]" zIndex="9999" />
        <div class="news-content">
          <div class="cont" v-html="textobj.messageContent" ref="richTextContainer" @click="showImg($event)"></div>
        </div>
        <div v-if="textobj.fileUrl" class="dolongw">
          <div class="dolong hover-underline" @click="download">
            <div class="file">
              <div class="image">
                <img src="../../assets/images/file.png" class="ims" alt="" />
              </div>
              <div>
                <span class="title">{{ textobj.fileUrl.slice(51) }}</span>
              </div>
            </div>
            <div class="dowl">
              <img src="../../assets/images/download.png" class="ims" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-info">
        <div class="bottom-box">
          <div>
            <span class="hover-underline" @click="tps(0)">首页</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(1)">地理位置</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(2)">联系我们</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(3)">技术支持</span>
          </div>
          <div>主办单位：池州市消防救援支队</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import iconv from "iconv-lite";

import { listInfo, listInfos, updateRelease } from "../../api/index";
export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      title: "安徽六市纪委监委通报！",
      author: "池州支队",
      from: "池州支队网",
      date: "2024-10-08",
      count: 10,
      url: "https://pic.rmb.bdstatic.com/8b0aa462eecac8129f458811ecb54962.jpeg",
      tableList: [],
      textobj: {},
      id: "",
      imgPreview: {
        img: "",
        show: false,
      },
      isShowPics: false,
      ids: "",
    };
  },
  // props: ["ids"],
  created() {
    const params = new URLSearchParams(window.location.search);
    this.ids = params.get("ids");
    this.id = Number(this.ids);
    this.getlistInfo();
  },
  mounted() {


  },
  methods: {
    modifyParagraphStyles() {
      // 获取包含富文本内容的容器
      this.$nextTick(() => {
        const container = this.$refs.richTextContainer;

        // 获取所有 p 标签
        const pTags = container.querySelectorAll('p');
        const imgTags = container.querySelectorAll('img');
        console.log(imgTags, '1');

        // 遍历并修改每个 p 标签的样式

        pTags.forEach(p => {
          p.style.margin = ' 0 '; // 设置文字颜色为蓝色
        });
        imgTags.forEach(p => {
          p.style.margin = '0 auto 10px '; // 设置文字颜色为蓝色
        });
      });
      console.log(this.$refs.richTextContainer);


    },
    tps(type) {
      let url
      if (type == 1) {
        url = `/?organization=地理位置`;
      } else if (type == 2) {
        url = `/?call=1`;
      } else if (type == 3) {
        url = `http://www.ahqmkeji.com/aboutus`;
      } else {
        url = `/`;
      }
      window.open(url, "_blank");
    },
    handlePreview() {
      this.isShowPics = true;
    },
    onPreview() {
      this.isShowPics = true;
    },
    // 关闭查看器
    closeViewer() {
      this.isShowPics = false;
    },
    showImg(e) {
      if (e.target.tagName == "IMG") {
        this.imgPreview.img = e.target.src;
        this.handlePreview();
      }
    },
    getlistInfo() {
      listInfo(this.id).then((res) => {
        this.textobj = res.data.data;
        this.modifyParagraphStyles(); // 在组件挂载后修改样式
        if (this.textobj.releaseTime) {
          this.textobj.releaseTime = this.textobj.releaseTime.slice(0, 10);
        }
        let viewTimes = this.textobj.viewTimes + 1;
        if (!this.textobj.viewTimes) {
          viewTimes = 1
          this.$set(this.textobj, "viewTimes", 0)
        }
        updateRelease({ id: this.textobj.id, viewTimes: viewTimes }).then((res) => {

        });
      });
    },
    returnshow() {
      this.$emit("setCilck");
    },
    download() {
      window.open(this.textobj.fileUrl);
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.cont>>>img {
  width: 600px;
  height: 200px;
}

.dolongw {
  width: 100%;
  padding: 40px;

  .dolong {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 80px);
    height: 40px;
    line-height: 35px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #f5f5f5;
    padding-left: 20px;

    .dowl {
      width: 34px;

      .ims {
        width: 12px;
        height: 14px;
        vertical-align: middle;
      }
    }

    .file {
      display: flex;

      .image {
        display: inline-block;
        height: 40px;

        .ims {
          width: 12px;
          height: 14px;
          vertical-align: middle;
        }
      }

      .title {
        margin-left: 8px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}

.container {
  width: 100%;
  background: #f0f5ff;
  display: flex;
  justify-content: center;

  .containerER {
    width: 1120px;
    background-color: #fff;
  }
}

.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }

  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }

  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}

.content {
  width: 1120px;
  margin: 0 auto;
  margin-top: 40px;

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    margin-bottom: 16px;
  }

  .line {
    width: 1040px;
    height: 2px;
    margin: 0 auto;
    margin-bottom: 16px;
    background: #2e5bb6;
  }

  .info {
    text-align: center;
  }

  .browse {
    width: 1040px;
    height: 16px;
    margin: 0 auto;
    font-size: 14px;
    color: #333333;
    position: relative;

    .count {
      position: absolute;
      right: 0;
    }
  }

  .img-box {
    width: 510px;
    height: 340px;
    margin: 0 auto;
    margin-bottom: 20px;

    img {
      width: 510px;
      height: 340px;
    }
  }

  .news-content {
    width: 1040px;
    margin: 0 40px;
    text-indent: 2em;

    ::v-deep img {
      display: block;
      margin: 0 auto;
      max-width: 50%;
    }

    // ::v-deep p {
    //   margin: 0;
    // }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: linear-gradient(180deg, #0E67AB 0%, #073456 100%);
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}

.red {
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 16px;
  color: #e71111;
}
</style>
